<template>
  <div id="app">
    <div class="wrapper">
      <va-navibar v-show="currentUser.authorized"></va-navibar>
      <va-slider :slideMenuItems="slideMenuItems" v-show="currentUser.authorized" :userRole="currentUser.position"></va-slider>
      <va-content-wrap></va-content-wrap>
      <Modal></Modal>
    </div>
  </div>
</template>

<script>
import VANaviBar from 'NaviBar.vue'
import VASlider from 'Slider.vue'
import VAContentWrap from 'ContentWrap.vue'
import Modal from './components/Modal.vue'
import store from './vuex/store.js'
import slideMenuItems from './lib/slideMenuItems.js'
import { mapGetters , mapActions } from 'vuex'
export default {
  name: 'app',
  data () {
    return {
      slideMenuItems: slideMenuItems
    }
  },
  created () {
    this.getLoginStatus()
  },
  components: {
    'va-navibar': VANaviBar,
    'va-slider': VASlider,
    'va-content-wrap': VAContentWrap,
    Modal
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
    methods: {
    ...mapActions([
      'getLoginStatus'
    ])
    },
  store
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?4c2c6ff1